import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

export interface WizzardHeaderButtonsProps extends GridProps {}

export const WizzardHeaderButtons = ({
  children,
  sx,
  ...rest
}: WizzardHeaderButtonsProps) => {
  return (
    <Grid
      sx={{
        w: '100%',
        gap: {
          base: 1,
          lg: 2,
        },
        gridAutoFlow: 'column',
        gridTemplateColumns: 'repeat(3, 1fr)',
        justifyContent: 'stretch',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Grid>
  )
}
